<template>
  <div class="article">
    <skeleton
      :count="20"
      template="lines"
      default-height="70vh"
      :content-ready="!asyncStatus.asyncDataLoading">
      <div class="article-content">
        <div
          v-for="section of article.sections"
          v-if="article.sections"
          class="section margin-max-bottom">
          <h3>{{ section.title }}</h3>
          <content-blocks :content="section.content"></content-blocks>
        </div>
      </div>
    </skeleton>
  </div>

  <!--
   <div>
    <h2 class="margin-xl-bottom">What are we doing</h2>
    <p>
      JustOpp is a unique digital marketplace, A B2B arena that will assist dealers and
      buyers to get premium brands and there excess stock directly from the manufactures
      and sellers with additional added values. JustOpp operates in different categories
      such as consumer electronics, Home appliances, IT, Mobile Etc.
    </p>

    <div class="article-space margin-max-bottom"></div>
    <h2 class="margin-xl-bottom">How does it work</h2>
    <p>
      JustOpp platform offers a complete online solution for small excessive stocks
      directly from the manufacturer/ sellers. JustOpp simplifies the buying and selling
      process. It offers buyers more choices from reputable sellers. It enables sellers to
      reach new potential buyers with the excessive stock they usually struggle with by
      dealing directly through the platform in one focal point for both buyer and seller-
      The JustOpp platform. It is easy to use and will change the way your business works.
      JustOpps dashboard will give you all the information on your transactions, available
      at any point of time and anywhere you are.
    </p>

    <div class="article-space margin-max-bottom"></div>
    <h2 class="margin-xl-bottom">Our Vision</h2>
    <p>
      To be the leading Digital Platform that handles excessive stocks while creating a
      new stream of income for both brand manufacturers and wholesalers worldwide
    </p>

    <div class="article-space margin-max-bottom"></div>
    <h2 class="margin-xl-bottom">Sellers and Buyers- Benefits</h2>
    <p>Turn expensive excessive stock into a new profitable stream of income</p>

    <h3>JustOpp offers an Innovative Digital B2B Platform for Excessive Stocks</h3>

    <ul>
      <li>
        <span>One Focal Point for the manufacturers and sellers</span>
      </li>
      <li>
        <span>A platform for selling small quantities surplus inventory</span>
      </li>
      <li>
        <span>Where manufacturers/ sellers and wholesalers meet</span>
      </li>
      <li>
        <span>First tier products for wholesalers</span>
      </li>
      <li>
        <span>A One-Stop-Shop for all transactions</span>
      </li>
      <li>
        <span>Zero Risk</span>
      </li>
    </ul>
  </div>
  -->
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import { reactive } from "vue";

export default {
  components: {},
  layout: {
    component: "default",
    params: reactive({
      title: "core.article.genericTitle",
      //   containerClass: "margin-remove-vertical",
    }),
  },
  middleware: {},
  props: {
    alias: {
      type: String,
      default: "about-us",
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();
    return { asyncOps, asyncOpsReady, asyncStatus };
  },
  meta: {
    title: "core.article.genericBrowserTitle",
  },
  data() {
    return {
      article: false,
      asyncData: {
        article: {
          target: "content/article/" + "about-us",
          data: {},
          options: {
            dataMutator(input) {
              if (input.item) {
                return input.item;
              }
              return false;
            },
          },
        },
      },
    };
  },
  computed: {},
  watch: {
    async article(newVal) {
      if (!newVal) {
        return;
      }
      let layoutConf = this[config.layoutAccessorKey]();
      if (newVal.title) {
        layoutConf.params.title = newVal.title;
      }

      if (newVal.subTitle) {
        layoutConf.params.subTitle = newVal.subTitle;
      }

      if (newVal.metaTitle) {
        this.meta.title = newVal.metaTitle;
      }
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped></style>
